export default "__VITE_ASSET__CnsU95pM__"